import { createApi } from '@reduxjs/toolkit/query/react';
import { GetFiltersByEnumResponse } from './models';
import { baseQueryWithReauth } from '../baseQueryWithReauth';

const filter_enums = 'filter_enums';

export const filterEnumsApi = createApi({
  reducerPath: filter_enums,
  baseQuery: baseQueryWithReauth,
  tagTypes: [filter_enums],
  endpoints: (build) => ({
    //ASAP TO FIX AT BE - card id needed at request
    getEnumsList: build.query<string[], { type: string }>({
      query: ({ type }) => {
        return {
          url: `/enums/${type}/list`,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
    }),
    getFiltersByEnum: build.query<GetFiltersByEnumResponse, { name: string }>({
      query: ({ name }) => {
        return {
          url: `/enums/${name}/filter`,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
    }),
    //to save to redux example
    // dispatch(filterEnumsActions.setEnums({
    //     name: 'channel',
    //     data: channelsRes.data
    // }))

    //to get from redux example
    // const channelEnums = useAppSelector(state => state.filterEnums.enums.channel)
  }),
});

export const { useGetEnumsListQuery, useGetFiltersByEnumQuery } = filterEnumsApi;
